<template>
    <div class="sign-contract" v-loading="pageLoading">
        <div class="content-box first">
            <el-descriptions :column="1" :title="contractDetail.contractAfterAdminName ? '签署个人账号升级为企业账号合同' : '签署企业授权合同'">
                <el-descriptions-item label="合同主要概要">
                    <template v-if="contractDetail.contractAfterAdminName">
                        将原个人授权代理合同
                        <span class="important">({{ contractDetail.contractBeforeAdminName }})</span>
                        的授权歌曲，通过企业
                        <span class="important">({{ contractDetail.contractAfterAdminName }})</span>
                        进行授权代理， 授权权利不变；专辑歌曲授权期限三年，到期后如果未通知，将会自动续约； 版税将会结算至您设置的企业收款账号
                    </template>
                    <template v-else>专辑歌曲授权期限三年，到期后如果未通知，将会自动续约；版税将会结算至您设置的收款账号</template>
                </el-descriptions-item>
                <el-descriptions-item label="授权地区">全球</el-descriptions-item>
                <el-descriptions-item label="授权权利">详见合同</el-descriptions-item>
            </el-descriptions>
            <iframe :src="contractDetail.contractFileFullPath"></iframe>
            <div class="page-btn-box">
                <el-button @click="$router.go(-1)">暂不签署</el-button>
                <el-button type="primary" @click="dialogVisible = true">开始签署</el-button>
            </div>
        </div>
        <!-- 个人升级企业签署弹框 -->
        <el-dialog
            title="签署合同"
            append-to-body
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="450px"
            center
        >
            <div class="contract-body">
                <steps :current-step="step" :steps="stepMap" style="margin-bottom: 0px"></steps>
                <!-- <div style="margin-top: 20px" v-if="status == 4">个人签署</div>
                <div style="margin-top: 20px" v-if="status == 5">企业签署</div> -->
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button v-if="status == 0 && !contractDetail.contractAfterAdminName" type="primary" @click="signContract(1)">确认签署</el-button>
                <el-button v-if="status == 0 && contractDetail.contractAfterAdminName" type="primary" @click="signContract(2, 1)">个人签署</el-button>
                <el-button v-if="status == 2 && contractDetail.contractAfterAdminName" type="primary" @click="signContract(2, 2)">企业签署</el-button>
                <el-button v-if="status == 5 || status == 4" type="primary" @click="openUrl()">继续签署</el-button>
                <el-button v-if="status == 5 || status == 4" type="base" @click="getContract()">完成签署</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import {fddEnterpriseContract, fddSendEnterpriseContract} from '@/api/user';
import Steps from '../components/steps.vue';
export default {
    components: {Steps},
    data() {
        return {
            pageLoading: false,
            dialogVisible: false,
            contractDetail: {},
            serialNumber: '',
            status: 0, // 0未签署 1 签署成功 2 合同一 3 合同二 4 签署中合同一 5 签署中合同二
            signContractLoading: false,
        };
    },
    computed: {
        step() {
            const {status} = this;
            return status < 2 || status == 4 ? 0 : 1;
        },
        stepMap() {
            const maps = [{title: '企业签署', icon: 'icon_over'}];
            if (this.contractDetail.contractAfterAdminName) maps.unshift({title: '个人签署', content: '个人签署'});
            return maps;
        },
    },
    mounted() {
        const {telephone} = this.$store.state.userInfo || {};
        if (telephone) this.telephone = telephone;
        this.getContract();
    },
    methods: {
        openUrl() {
            window.open(this.contractDetail.fddSignUrl);
        },
        // 签署合同
        async signContract(type, step) {
            if (this.signContractLoading) return;
            this.signContractLoading = true;
            const response = await fddSendEnterpriseContract(type, step);
            const {state, msg, result} = response.data;
            this.signContractLoading = false;
            if (!state) return this.$message.error(msg || '抱歉，签署失败');
            window.open(result);
            this.status = 1;
            this.getContract();
        },
        // 获取合同
        async getContract() {
            this.pageLoading = true;
            const respnose = await fddEnterpriseContract();
            const {state, msg, result} = respnose.data;
            this.pageLoading = false;
            if (!state) return this.$message.error(msg || '获取数据失败,请重试');
            this.contractDetail = result;
            const {fddSignStatus} = result || {};
            this.status = fddSignStatus;
            // 签署成功
            if (fddSignStatus === 1) {
                await this.$store.dispatch('getEnterpriseCertify', true);
                await this.$store.dispatch('getUserInfo');
                return (window.location.href = '/manage/accountManage');
            }
            if (fddSignStatus !== 0 && fddSignStatus !== 1) this.dialogVisible = true;
        },
    },
};
</script>
<style lang="scss">
.sign-contract {
    overflow: hidden;
    border-radius: 0px 0px 6px 6px;

    .content-box {
        padding: 50px 40px;
    }

    .el-descriptions-item__label {
        width: 125px;
    }

    .el-descriptions-item__content {
        flex: 1;
        display: block;
    }

    iframe {
        border: none;
        width: 100%;
        height: 500px;
        margin-top: 40px;
    }
}

.contract-body {
    .item {
        display: flex;
        margin-top: 10px;

        label {
            width: 60px;
            line-height: 40px;
        }

        .cont {
            flex: 1;
            display: flex;
        }
    }
}
</style>
